import request from '@/utils/request'

/**
 * 获取提现申请列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function listStateWithdrawalApplys(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/accountWithdrawalApply/listStateWithdrawalApplys',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新提现申请状态
 * @param {Object} data 更新数据
 * @returns {Promise} Promise对象
 */
export function upAccountWithdrawalApply(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/accountWithdrawalApply/upAccountWithdrawalApply',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询银行账户信息
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryAccountBank(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/accountBank/queryAccountBank',
      method: 'get',
      params: {
        page: 1,
        row: 50,
        ...params
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}